import Vue from 'vue'
import VueRouter from 'vue-router'
import layouts from '@/layouts/mainIndex.vue'

Vue.use(VueRouter)

//解决编程式路由往同一地址跳转时会报错的情况
const originalPush = VueRouter.prototype.push
const originalReplace = VueRouter.prototype.replace
//push
VueRouter.prototype.push = function push(location, onResolve, onReject) {
  if (onResolve || onReject) return originalPush.call(this, location, onResolve, onReject)
  return originalPush.call(this, location).catch(err => err)
}
//replace
VueRouter.prototype.replace = function push(location, onResolve, onReject) {
  if (onResolve || onReject) return originalReplace.call(this, location, onResolve, onReject)
  return originalReplace.call(this, location).catch(err => err)
}
// 角色权限
// 2：管理员；3：教务员；4：学院管理员；5：教师；6：学生；7：游客
export const routes = [
  {
    path: '/',
    component: layouts,
    redirect: '/index',
    children: [
      {
        path: '/index',
        name: 'index',
        component: () => import('@/views/platform/index.vue'),
        meta: {
          title: '平台',
          activeTop: 'nav-platform',
          activeSub: 'nav-platform-index',
        },
      },
      {
        path: '/platform/attributeCourse',
        name: 'attributeCourse',
        component: () => import('@/views/platform/attributeCourse.vue'),
        meta: {
          title: '属性课程',
          activeTop: 'nav-platform',
          activeSub: 'sub-platform',
        },
      },
      {
        path: '/platform/invalidCourse',
        name: 'invalidCourse',
        component: () => import('@/views/platform/invalidCourse.vue'),
        meta: {
          title: '无效课程',
          activeTop: 'nav-platform',
          activeSub: 'nav-invalid-course',
        },
      },
      {
        path: '/platform/accessAnalyse',
        name: 'accessAnalyse',
        component: () => import('@/views/platform/accessAnalyse.vue'),
        meta: {
          title: '访问分析',
          activeTop: 'nav-platform',
          activeSub: 'nav-access-analyse',
        },
      },
    ],
  },
  {
    path: '/course',
    component: layouts,
    children: [
      {
        path: '/course',
        name: 'course',
        component: () => import('@/views/course/index.vue'),
        meta: {
          title: '所有课程',
          activeTop: 'nav-course',
          activeSub: 'nav-course-index',
        },
      },
      {
        path: '/course/courseRank',
        name: 'courseRank',
        component: () => import('@/views/course/courseRank/index.vue'),
        meta: {
          title: '课程排行',
          activeTop: 'nav-course',
          activeSub: 'nav-course-rank',
        },
      },
      {
        path: '/course/courseRank/activeRank',
        name: 'activeRank',
        component: () => import('@/views/course/courseRank/activeRank.vue'),
        meta: {
          title: '活跃度排行',
          activeTop: 'nav-course',
          activeSub: 'nav-course-rank',
        },
      },
      {
        path: '/course/courseRank/publishRank',
        name: 'publishRank',
        component: () => import('@/views/course/courseRank/publishRank.vue'),
        meta: {
          title: '课程发布排行',
          activeTop: 'nav-course',
          activeSub: 'nav-course-rank',
        },
      },
      {
        path: '/course/courseRank/resourceRank',
        name: 'resourceRank',
        component: () => import('@/views/course/courseRank/resourceRank.vue'),
        meta: {
          title: '课程资源排行',
          activeTop: 'nav-course',
          activeSub: 'nav-course-rank',
        },
      },
      {
        path: '/course/courseRank/discussRank',
        name: 'discussRank',
        component: () => import('@/views/course/courseRank/discussRank.vue'),
        meta: {
          title: '课程讨论排行',
          activeTop: 'nav-course',
          activeSub: 'nav-course-rank',
        },
      },
    ],
  },

  {
    path: '/courseDetail',
    component: layouts,
    children: [
      {
        path: '/courseDetail',
        name: 'courseDetail',
        component: () => import('@/views/course/courseDetail.vue'),
        redirect: '/courseDetail/baseInfo',
        meta: {
          title: '课程详情',
          activeTop: 'nav-course',
          activeSub: 'nav-course-index',
        },
        children: [
          {
            path: '/courseDetail/baseInfo',
            name: 'baseInfo',
            component: () => import('@/views/course/baseInfo/index.vue'),
            meta: {
              title: '基本情况',
              activeMenu: '/courseDetail/baseInfo',
              activeTop: 'nav-course',
              activeSub: 'nav-course-index',
            },
          },
          {
            path: '/courseDetail/teachCount',
            name: 'teachCount',
            component: () => import('@/views/course/teachCount/index.vue'),
            meta: {
              title: '教学统计',
              activeMenu: '/courseDetail/teachCount',
              activeTop: 'nav-course',
              activeSub: 'nav-course-index',
            },
          },
          {
            path: '/courseDetail/teachCount/courseActivity',
            name: 'teachActivity',
            component: () => import('@/views/course/teachCount/courseActivity.vue'),
            meta: {
              title: '教学活动详情',
              activeMenu: '/courseDetail/teachCount',
              activeTop: 'nav-course',
              activeSub: 'nav-course-index',
            },
          },
          {
            path: '/courseDetail/studyAnalyse',
            name: 'studyAnalyse',
            component: () => import('@/views/course/studyAnalyse/index.vue'),
            meta: {
              title: '学情分析',
              activeMenu: '/courseDetail/studyAnalyse',
              activeTop: 'nav-course',
              activeSub: 'nav-course-index',
            },
          },
          {
            path: '/courseDetail/studentDoc',
            name: 'studentDoc',
            component: () => import('@/views/course/studentDoc/index.vue'),
            meta: {
              title: '学员档案',
              activeMenu: '/courseDetail/studentDoc',
              activeTop: 'nav-course',
              activeSub: 'nav-course-index',
            },
          },
          {
            path: '/courseDetail/myDoc',
            name: 'myDoc',
            component: () => import('@/views/course/studentDoc/studentDetail.vue'),
            meta: {
              title: '我的档案',
              activeMenu: '/courseDetail/studentDoc',
              activeTop: 'nav-course',
              activeSub: 'nav-course-index',
            },
          },
          {
            path: '/courseDetail/studentDoc/studentDetail',
            name: 'studentDetail',
            component: () => import('@/views/course/studentDoc/studentDetail.vue'),
            meta: {
              title: '学员档案详情',
              activeMenu: '/courseDetail/studentDoc',
              activeTop: 'nav-course',
              activeSub: 'nav-course-index',
            },
          },
          {
            path: '/courseDetail/abnormalWarn',
            name: 'abnormalWarn',
            component: () => import('@/views/course/abnormalWarn/index.vue'),
            meta: {
              title: '异常预警',
              activeMenu: '/courseDetail/abnormalWarn',
              activeTop: 'nav-course',
              activeSub: 'nav-course-index',
            },
          },
        ],
      },
    ],
  },

  {
    path: '/term',
    component: layouts,
    children: [
      {
        path: '/term',
        name: 'term',
        component: () => import('@/views/term/index.vue'),
        meta: {
          title: '学期基本概况',
          activeTop: 'nav-term',
          activeSub: 'nav-term-index',
        },
      },
      {
        path: '/term/reports',
        name: 'termReport',
        component: () => import('@/views/term/reports.vue'),
        meta: {
          title: '学期报告',
          activeTop: 'nav-term',
          activeSub: 'nav-term-reports',
        },
      },
    ],
  },
  {
    path: '/supervision',
    component: layouts,
    children: [
      {
        path: '/supervision',
        name: 'supervision',
        component: () => import('@/views/supervision/index.vue'),
        meta: {
          title: '学院建设情况统计',
          activeTop: 'nav-supervision',
          activeSub: 'nav-supervision-index',
        },
      },
      {
        path: '/supervision/courseStatistic',
        name: 'courseStatistic',
        component: () => import('@/views/supervision/courseStatistic.vue'),
        meta: {
          title: '课程建设情况统计',
          activeTop: 'nav-supervision',
          activeSub: 'nav-supervision-course',
        },
      },
      {
        path: '/supervision/teacherStatistic',
        name: 'teacherStatistic',
        component: () => import('@/views/supervision/teacherStatistic.vue'),
        meta: {
          title: '课程教师行为统计',
          activeTop: 'nav-supervision',
          activeSub: 'nav-supervision-teacher',
        },
      },
      {
        path: '/supervision/studentStatistic',
        name: 'studentStatistic',
        component: () => import('@/views/supervision/studentStatistic.vue'),
        meta: {
          title: '课程学生行为统计',
          activeTop: 'nav-supervision',
          activeSub: 'nav-supervision-student',
        },
      },
    ],
  },
]

const router = new VueRouter({
  routes,
  mode: 'hash',
})

export default router
